/** Same options as Oncall → Processing Jobs → Actions status dropdown. */
export const PATIENT_STATUS_OPTIONS = [
  "Ready to Record",
  "Uploading Audio",
  "Processing Audio",
  "Review",
  "Locked",
];

export const isNoteLocked = (status) =>
  String(status || "").trim().toLowerCase() === "locked";

/** Same options as Oncall → Patient → Patient Details dialog → Patient Type. */
export const PATIENT_TYPE_OPTIONS = ["new", "fu", "telemed"];

/** Cobalt import that can be uploaded to 4D EMR. */
export const FOUR_D_IMPORT_TYPE = "Cobalt-API-4DEMR";
